module.exports = __webpack_public_path__ + "img/jingqupiaowu.ff1def79.png";